import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62a5258e&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=62a5258e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a5258e",
  null
  
)

export default component.exports